import React, { useEffect, useState } from 'react'
import PopUp from "../../../../../presentationals/Popup/Popup.component";
import { SaveUpdateAssetVehicleDetails } from '../../../AdminActionCreator.component';

export default function VehicleInfo({ documentsData, admin, userdata, editHandler }) {
    const [data, setData] = useState({
        batterySerialNumber: "",
        vehicleRegistrationNumber: "",
    })
    const [popup, setPopup] = useState({ show: false, popupStatus: "" })

    const onChangeHandler = (e, type) => {
        const { value } = e.target;

        setData((prev) => ({
            ...prev,
            [type]: value
        }))
    }

    useEffect(() => {
        setData({
            batterySerialNumber: documentsData?.assetAndVehicleDetailDO?.batterySerialNumber,
            vehicleRegistrationNumber: documentsData?.assetAndVehicleDetailDO?.vehicleRegistrationNumber,
        })
    }, [])


    const onSubmitHandler = () => {
        console.log("documentsData", documentsData?.assetAndVehicleDetailDO)
        const ds = { ...documentsData?.assetAndVehicleDetailDO, batterySerialNumber: data?.batterySerialNumber, vehicleRegistrationNumber: data?.vehicleRegistrationNumber }

        SaveUpdateAssetVehicleDetails(ds, callback => {
            console.log("call", callback)
            if(callback?.message == "success"){
                setPopup({ show: true, popupStatus: "Data Updated Successfully" })
            }else{
                 setPopup({show:true,popupStatus:"Error Updating Data"})
            }
            removePopup()
        })

    }

    const closePopup = () => {
        setPopup({ show: false, popupStatus: "" })
    }

    const removePopup = () => {
        setTimeout(() => {
            closePopup()
        }, 5000)
    }
    return (
        <>
            {
                popup?.show ? <PopUp popupStatus={popup?.popupStatus} closePopup={closePopup} /> : ""
            }
            <div className="details-new background-blur" style={{ background: 'rgb(5 5 5 / 20%)', color: '#000' }}>
                <div className="edit-box ">
                    <div className="text-right" style={{ color: 'red' }}><i onClick={() => editHandler('')} style={{ fontSize: '20px', cursor: 'pointer' }} className="fa fa-times"></i></div>

                    <h4><b>Edit Vehicle Details</b></h4>

                    <div className="row" style={{ marginTop: '20px' }}>
                        <div className="col-sm-4 col-xs-12">
                            <label>Battery Serial No</label>
                            <input type="text" className="form-control" value={data?.batterySerialNumber} onChange={(e) => onChangeHandler(e, "batterySerialNumber")} />

                        </div>
                        <div className="col-sm-4 col-xs-12">
                            <label>Vehicle Registration No</label>
                            <input type="text" className="form-control" value={data.vehicleRegistrationNumber} onChange={(e) => onChangeHandler(e, "vehicleRegistrationNumber")} />

                        </div>

                    </div>


                    <div className="row " style={{ marginTop: '20px' }}>
                        <div className="col-xs-12">
                            <button className="btn btn-primary" id="" onClick={(e) => onSubmitHandler(e)}>
                                Update Vehicle Details
                            </button>
                        </div>
                    </div>



                </div>

            </div>
        </>
    )
}
